import update3dTileStyle from '$lib/utils/tilestyle-util';
import { Cesium3DTileset, Cesium3DTileStyle, defined } from 'cesium';
import { useCesiumViewer } from './cesium-viewer';

/**
 * Util used for controlling wether a tileset is shown or not.
 * 
 * @param tileset 
 * @returns boolean
 */
const controlChecked = (tileset: Cesium3DTileset) => {
	const { scene } = useCesiumViewer()
	return scene.primitives.contains(tileset) && tileset.show;
};

/**
 * Util for simple import (into other files) of 3D tiles map layers.
 */
const get3DTilesMapLayers = async () => {
	const norkartObjectsTileset = await Cesium3DTileset.fromUrl(
		'https://waapi.webatlas.no/3d-tiles/tileserver.fcgi/tileset.json?api_key=06be3cd6-2849-49ef-8baf-429acc040709',
		{
			maximumScreenSpaceError: 32,
			skipLevelOfDetail: true,
			immediatelyLoadDesiredLevelOfDetail: true
		},
	).then((tileset) => {
		tileset.showOutline = false;
		const norkartTileStyle = update3dTileStyle({
			showLv: false,
			showHv: false,
			showLight: false
		});

		if (defined(norkartTileStyle)) {
			try {
				tileset.style = new Cesium3DTileStyle(
					norkartTileStyle
				);
			} catch (e) {
				console.error('Kunne ikke style');
			}
		}
		return tileset;
	});
	

	const norkartForestryTileset = await Cesium3DTileset.fromUrl(
		'https://waapi.webatlas.no/3d-tiles/tileserver_skog.fcgi/tileset.json?api_key=06be3cd6-2849-49ef-8baf-429acc040709',
		{
			maximumScreenSpaceError: 32,
			skipLevelOfDetail: true,
			immediatelyLoadDesiredLevelOfDetail: true
		}
	);
	return { norkartObjectsTileset, norkartForestryTileset };
};

export { controlChecked, get3DTilesMapLayers };
